import React from 'react';
import FolderIcon from '@mui/icons-material/Folder';
import CategoryIcon from '@mui/icons-material/Category';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';
import TagIcon from '@mui/icons-material/Tag';
import BarChartIcon from '@mui/icons-material/BarChart';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LabelIcon from '@mui/icons-material/Label';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PersonIcon from '@mui/icons-material/Person';
import StoreIcon from '@mui/icons-material/Store';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import { TreeNode } from '../../types';

export default function getTreeNodeIcon(node: TreeNode) {
  switch (node.type) {
    case 'domain':
      return <FolderIcon fontSize="small" color="primary" />;
    case 'group':
      return <CategoryIcon fontSize="small" color="action" />;
    case 'metric':
      switch (node.dataType) {
        case 'currency': return <AttachMoneyIcon fontSize="small" sx={{ color: 'var(--ok)' }} />;
        case 'percentage': return <PercentIcon fontSize="small" sx={{ color: 'var(--warn)' }} />;
        case 'integer':
        case 'number': return <TagIcon fontSize="small" sx={{ color: 'var(--accent)' }} />;
        default: return <BarChartIcon fontSize="small" sx={{ color: 'var(--accent)' }} />;
      }
    case 'dimension':
      switch (node.dataType) {
        case 'date': return <CalendarMonthIcon fontSize="small" sx={{ color: 'var(--accent)' }} />;
        case 'boolean': return <ToggleOnIcon fontSize="small" sx={{ color: 'var(--agent)' }} />;
        case 'json': return <DataObjectIcon fontSize="small" sx={{ color: 'var(--agent)' }} />;
        case 'integer':
        case 'number': return <TagIcon fontSize="small" sx={{ color: 'var(--accent)' }} />;
        case 'categorical': return <LabelIcon fontSize="small" sx={{ color: 'var(--agent)' }} />;
        default: return <ViewColumnIcon fontSize="small" sx={{ color: 'var(--agent)' }} />;
      }
    case 'date_hierarchy':
      return <CalendarTodayIcon fontSize="small" sx={{ color: 'var(--accent)' }} />;
    case 'inherited_model':
      switch (node.metadata?.icon) {
        case 'person': return <PersonIcon fontSize="small" sx={{ color: 'var(--ok)' }} />;
        case 'store': return <StoreIcon fontSize="small" sx={{ color: 'var(--ok)' }} />;
        case 'loyalty': return <LoyaltyIcon fontSize="small" sx={{ color: 'var(--ok)' }} />;
        default: return <AccountTreeIcon fontSize="small" sx={{ color: 'var(--ok)' }} />;
      }
    default:
      return <AccountTreeIcon fontSize="small" />;
  }
}
